<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="search"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
      />
      <meta-button v-if="edit" type="new" @click="$emit('form')" />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="formatedList"
        :loading="loading"
        :rows-per-page-items="[10, 25, 50]"
        disable-initial-sort
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <template slot="items" slot-scope="props">
          <td v-if="edit" class="text-xs-center px-0">
            <v-icon
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon color="error" @click="ifDelete(props.item._id)">
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td style="min-width: 150px">
            {{ props.item.name }}
          </td>
          <!-- <td>{{ props.item.description }}</td> -->
          <td style="min-width: 250px">
            {{ props.item.stadium }}
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.status" />
          </td>
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'RbpiList',
  components: { DialogDelete, DialogUpdatedRecord },
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      search: '',
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    search() {
      if (this.localPagination.page !== 1) this.localPagination.page = 1
      else this.debounceFetch()
    },
    'localPagination.page': {
      handler: function (/* val, oldVal */) {
        this.fetchList({ match: this.search })
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.rbpi.loading,
      selected: (state) => state.rbpi.selected,
      pagination: (state) => state.rbpi.pagination,
    }),
    ...mapGetters({
      formatedList: 'rbpi/formatedList',
    }),
    headers() {
      let headers = []
      if (this.edit) {
        headers.push({
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        })
      }
      headers = headers.concat([
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        // {
        //   text: this.$t('titles.roles.description'),
        //   value: 'description'
        // },
        {
          text: this.$tc('models.stadium'),
          value: 'stadium',
        },
        {
          text: this.$t('titles.matches.status'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ])

      return headers
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('rbpi/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'rbpi/fetchOne',
      setDelete: 'rbpi/delete',
      reset: 'rbpi/reset',
      fetchList: 'rbpi/fetchList',
    }),
    setOne(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => this.$emit('form'))
    },
    openUpdated(id) {
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    debounceFetch: debounce(function () {
      this.fetchList({
        match: this.search,
      })
    }, 1000),
  },
}
</script>
